import { combineReducers } from '@reduxjs/toolkit';
import { all, fork } from 'redux-saga/effects';
import accordionStepsSaga from './accordion.saga';
import accordionstepsSlice from './accordion.slice';
import accountSaga from './account.saga';
import accountSlice from './account.slice';
export const accountRootReducer = combineReducers({
    account: accountSlice.reducer,
    step: accordionstepsSlice.reducer
});
export function* accountRootSaga() {
    yield all([fork(accountSaga), fork(accordionStepsSaga)]);
}
